import * as React from 'react'
import { cn } from '../../lib/utils'

export interface AvatarButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	icon: React.ReactNode
	label: string
}

const AvatarButton = React.forwardRef<HTMLButtonElement, AvatarButtonProps>(
	({ className, icon, label, disabled, ...props }, ref) => {
		return (
			<button
				ref={ref}
				disabled={disabled}
				className={cn(
					'group inline-flex items-center gap-3 cursor-pointer',
					'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--color-ring) focus-visible:ring-offset-2',
					'disabled:pointer-events-none',
					className
				)}
				{...props}
			>
				<span
					className={cn(
						'relative flex items-center justify-center size-10 rounded-lg shrink-0',
						'bg-(--color-brand-50) group-hover:bg-(--color-brand-light)',
						'transition-colors duration-150',
						'text-(--color-brand)',
						disabled && 'opacity-50'
					)}
				>
					{icon}
				</span>
				<span
					className={cn(
						'text-sm font-medium leading-6 whitespace-nowrap',
						'text-(--color-brand) group-hover:text-(--color-brand-hover)',
						'transition-colors duration-150',
						disabled && 'opacity-50'
					)}
				>
					{label}
				</span>
			</button>
		)
	}
)

AvatarButton.displayName = 'AvatarButton'

export { AvatarButton }
